<template>
    <div style="background-color: #f2f2f2">
        <MyFeedHeader title="마이피드"></MyFeedHeader>
        <InfinityScroll :is-enable-next-page-handle="isEnableNextPageHandle" :handle-next-page="handleNextPage" :refresh-action="refresh" style="overflow:auto; flex:1;">
            <div style="padding:30px 15px;">
                <MyFeedLabel icon="reservation.png" label="출석/결석" :isArrowHidden="true" :count="reservationCount"></MyFeedLabel>
            </div>
            <div v-for="each, i in eventList" class="membership_wrap" :key="i">
                <div style="display:flex; flex-direction: column;">
                    <div class="schedule_top" style=""
                         :class="[
                            each.info_type === '출석' ? 'schedule_top_attend' : '',
                            each.info_type === '취소' ? 'schedule_top_cancel' : '',
                            each.info_type === '결석' ? 'schedule_top_absent' : '',
                            each.info_type === '취소' ? 'font_color_cancel' : ''
                         ]">
                        <div style="margin-top:10px; padding-left:8px; font-size:15px; font-weight: normal;">{{$Util.getYYYYDotMMDotDDDayStr(each.schedule_date)}} {{each.begin_time}} ~ {{each.end_time}}</div>
                        <div style="font-size:16px;padding-left:8px; margin-top:13px; ">{{each.program_name}}<span style="float:right; font-size:18px;color:white;" v-if="each.info_type !== '예약'">{{each.info_type}}</span></div>
                    </div>
                    <div style="position:relative; padding:10px 40px;background-color: white; border-bottom-right-radius: 10px; border-bottom-left-radius:10px; ">
                        <div class="schedule_name" style="" :class="[each.info_type === '취소' ? 'font_color_cancel' : '']">{{$GlobalStore.loginInfo().name}}</div>
                        <div class="membership_info" style="margin-top:10px;">
                            <div class="membership_label">회원권</div><div class="membership_conts" :class="[each.info_type === '취소' ? 'font_color_cancel' : '']">{{each.membership_name}}</div>
                        </div>
                        <div class="membership_info">
                            <div class="membership_label">기간</div><div class="membership_conts" :class="[each.info_type === '취소' ? 'font_color_cancel' : '']"><div v-if="each.begin_date == ''">무제한</div><div v-else>{{each.begin_date | dotDate}} - {{each.end_date | dotDate}}</div></div>
                        </div>
                        <div class="membership_info">
                            <div class="membership_label">회차</div><div class="membership_conts" :class="[each.info_type === '취소' ? 'font_color_cancel' : '']">{{each.seq + "회차/ "}}{{each.coupon_count == 0 ? '무제한' : each.coupon_count + '회'}}</div>
                        </div>
                        <div class="membership_info">
                            <div class="membership_label">예약코치</div><div class="membership_conts" :class="[each.info_type === '취소' ? 'font_color_cancel' : '']">{{each.coach_name}}</div>
                        </div>
                        <div style="left:-20px;" class="round"></div>
                        <div style="right:-20px;" class="round"></div>
                    </div>
                    <div style=" text-align:right; margin-top:15px;" v-if="each.cancelPossible === 1 && (each.info_type === '예약' || each.info_type === '대기')">
                        <div class="btns" style="background-color: #ff7703; margin-right:20px; color:white;text-align:center;" @click="showCancelConfirm(each.schedule_idx, each.saleMembership_idx)">예약취소</div>
                    </div>
                </div>
            </div>
            <div style="height:10px;"></div>
        </InfinityScroll>
        <div v-if="isShowCancelConfirm">
            <div style="position:fixed; top :0px; left:0px; width:100%; height:100%; display:grid; place-items: center; background-color: rgba(0,0,0, 0.2)" @click.stop="() => {isShowCancelConfirm = false}">
                <div style="width:300px; background-color: white; border-radius: 15px; padding:30px 0px 15px 0px;text-align:center;">
                    <div style="font-weight:bold; color:#ff7703;">레슨 취소</div>
                    <div style="margin-top:20px; font-size:16px; font-weight:bold;line-height:16px;">해당 레슨을 취소하시겠습니까?</div>
                    <div style="font-weight:bold; font-size:15px; color:#ff7703; margin-top:30px;" @click.stop="cancelReservation">레슨 취소하기</div>
                    <div style="font-weight:bold; font-size:15px; margin-top:20px;" @click.stop="() => {isShowCancelConfirm = false}">뒤로가기</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import MyFeedHeader from "../../common/MyFeedHeader";
    import InfinityScroll from "../../common/InfinityScroll";
    import MyFeedLabel from "../../common/MyFeedLabel";
    export default {
        name: "LessonSchedules",
        props : {
            reservationCount : {
                type : Number,
                default : 0,
            }
        },
        components: {MyFeedLabel, InfinityScroll, MyFeedHeader},
        data(){
            return {
                isEnableNextPageHandle : true,
                eventList : [],
                page : 1,
                isShowCancelConfirm : false,
                scheduleIdx : -1,
                saleMembershipIdx : -1,
            }
        },
        methods : {
            async getLessonSchedules(){
                this.isEnableNextPageHandle = false;

                const parameters = {page : this.page};
                const res = await this.$Axios.get('/api/myschdule', {params : parameters});
                const eventList = res.data.eventList;

                if(eventList.length > 0){
                    this.eventList = [...this.eventList, ...eventList];
                    this.isEnableNextPageHandle = true;
                }
            },
            handleNextPage(){
                this.page++;
                this.getLessonSchedules();
            },
            showCancelConfirm(scheduleIdx, saleMembershipIdx){
                this.scheduleIdx = scheduleIdx;
                this.saleMembershipIdx = saleMembershipIdx;
                this.isShowCancelConfirm = true;
            },
            async cancelReservation(){

                this.isShowCancelConfirm = false;
                const parameters = {};
                parameters.scheduleIdx = this.scheduleIdx;
                parameters.saleMembershipIdx = this.saleMembershipIdx;

                const res = await this.$Axios.post('/api/reservation/cancel', parameters);
                if(res.data.code === 0){
                    this.isEnableNextPageHandle = true;
                    this.page = 1;
                    this.eventList = [];
                    this.getLessonSchedules();
                }else {
                    this.$GlobalStore.showAlert(res.data.msg);
                }
            },
            refresh(){
                this.isEnableNextPageHandle = true;
                this.page = 1;
                this.eventList = [];
                this.getLessonSchedules();
            }

        },
        created(){
            this.cancelReservation = this.$Once(this.cancelReservation);
            this.getLessonSchedules();
        }
    }
</script>

<style scoped>
    .schedule_top{border-top-left-radius: 10px; border-top-right-radius: 10px; color:white; padding:10px; background-color: #ff7703; }
    .membership_wrap{padding:0px 20px; }
    .membership_wrap + .membership_wrap{
        margin-top:20px;
    }
    .membership_info{display:flex;}
    .membership_info + .membership_info{margin-top:8px;}
    .membership_label{font-size:13px; width:70px; color:#bbbbbb;}
    .membership_conts{font-size:13px; color:#464646; font-weight:bold;}
    .btns{display:inline-block; height:40px; font-size:15px; line-height:40px; border-radius:20px; width:140px;}
    .btns + .btns{margin-left:15px;}
    .round{position:absolute; top: 10px; width:40px; height:40px; border-radius:50%; background-color: #f2f2f2;}
    .schedule_name{font-size:17px; font-weight: bold; color:#464646; margin-top:5px;}
    .schedule_top_attend{background-color:#fdd2ad;}
    .schedule_top_cancel{background-color:#9a9a9a;}
    .schedule_top_absent{background-color: #b6b5b6;}
    .font_color_cancel{color:#bbbbbb;}
</style>